import React, { useEffect, useState } from "react"
import { Box, CircularProgress } from "@mui/material"

const Eula = () => {
  const [html, setHtml] = useState("")
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()
    const eulaHtmlUrl = `${process.env.PUBLIC_URL}/eula.html`

    const loadHtml = async () => {
      try {
        const response = await fetch(eulaHtmlUrl, { signal: controller.signal })
        const text = await response.text()
        setHtml(text)
      } catch (error) {
        if (error instanceof DOMException && error.name === "AbortError") {
          return
        }
        // eslint-disable-next-line no-console
        console.error("Failed to load EULA HTML", error)
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false)
        }
      }
    }

    loadHtml()

    return () => controller.abort()
  }, [])

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "background.default" }}>
      <Box sx={{ width: "100%", p: { xs: 2, md: 4 } }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </Box>
    </Box>
  )
}

export default Eula
